import { CellType } from './cell'
import { lineFromVehicle } from '../lineAppearance'

const scheduledDestinationCellFromTicketsHop = (response, hopIndex) => {
  const hop = response.hops[hopIndex]

  const line = response.lines[hop.line]
  const placeIndex = line.places[line.places.length - 1]
  const place = response.places[placeIndex]
  const vehicle = response.vehicles[hop.vehicle]

  return {
    type: CellType.Destination,
    primaryText: place.name,
    ...(place.code) && { airportCode: place.code },
    localTime: hop.arrivalTime,
    line: lineFromVehicle(vehicle.kind),
  }
}

const scheduledDestinationCellFromCheckoutHop = (hop) => {
  return {
    type: CellType.Destination,
    primaryText: hop.destination,
    ...(hop.code) && { airportCode: hop.code },
    localTime: hop.arrivalTime.substring(11, 16),
    line: lineFromVehicle(hop.kind),
  }
}

export {
  scheduledDestinationCellFromTicketsHop,
  scheduledDestinationCellFromCheckoutHop
}
